import * as Yup from 'yup';

export const ListSchema = Yup.object().shape({
  list_name: Yup.string().required('List name is required').max(120, 'List name cannot exceed 120 characters'),
});
